<pds-form [formGroup]="settingFormGroup">
  <pds-form-section title="Auditoria">
    <pds-form-row grid="1-1-1-1">
      <pds-form-field label="Versão">
        <input type="text" formControlName="version" />
      </pds-form-field>
      <pds-form-field label="Alterado por">
        <input type="text" formControlName="updatedBy" />
      </pds-form-field>
      <pds-form-field label="Alterado em">
        <input type="datetime" formControlName="updatedAt" />
      </pds-form-field>
      <pds-form-field label="aplicar versão anterior">
        <select formControlName="selectVersion">
          <option *ngFor="let v of versions" [value]="v" [selected]="v === settingFormGroup.get('selectVersion')?.value">
            {{ v }}
          </option>
        </select>
      </pds-form-field>
    </pds-form-row>
  </pds-form-section>

  <pds-form-section title="Produto">
    <pds-form-row grid="1-1-1">
      <pds-form-field label="Custo fixo por fornecedor">
        <input type="text" placeholder="R$ 0,00" formControlName="fixedCostPerSeller" pdsCurrencyMask />
      </pds-form-field>
      <pds-form-field label="Tipo de diferença de custo máxima">
        <select formControlName="maxDiffCostType">
          <option value="currency">R$</option>
          <option value="percentage">%</option>
        </select>
      </pds-form-field>
      @if (settingFormGroup.get('maxDiffCostType')?.value === 'currency') {
      <pds-form-field label="Diferença de custo máxima">
        <input type="text" placeholder="R$ 0,00" formControlName="maxDiffCostPerProduct" pdsCurrencyMask />
      </pds-form-field>
      } @else {
      <pds-form-field label="Diferença de custo máxima (%)">
        <input type="text" placeholder="0,00 %" formControlName="maxDiffCostPerProductPercentage" pdsMask="99,99%" />
      </pds-form-field>
      }
    </pds-form-row>
  </pds-form-section>

  <pds-form-section title="Frete">
    <pds-form-row>
      <pds-form-field label="Custo máximo por KM">
        <input type="text" placeholder="R$ 0,00" formControlName="costPerKm" pdsCurrencyMask />
      </pds-form-field>
    </pds-form-row>
  </pds-form-section>

  <pds-form-actions>
    <button pdsButton="primary" (click)="onReset()">Descartar</button>
    <button pdsButton (click)="onSave()">Salvar</button>
  </pds-form-actions>
</pds-form>
